
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Calendar, TrendingUp } from 'lucide-react';

interface StatsCardsProps {
  stats: {
    total: number;
    today: number;
    thisWeek: number;
    interviewInterested: number;
  };
}

export const StatsCards = ({ stats }: StatsCardsProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-8">
      <Card className="bg-white shadow-sm">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium text-gray-700">Total Records</CardTitle>
          <Users className="h-3 w-3 md:h-4 md:w-4 text-gray-600" />
        </CardHeader>
        <CardContent className="pt-1">
          <div className="text-lg md:text-2xl font-bold text-gray-900">{stats.total}</div>
        </CardContent>
      </Card>

      <Card className="bg-white shadow-sm">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium text-gray-700">Today</CardTitle>
          <Calendar className="h-3 w-3 md:h-4 md:w-4 text-gray-600" />
        </CardHeader>
        <CardContent className="pt-1">
          <div className="text-lg md:text-2xl font-bold text-gray-900">{stats.today}</div>
        </CardContent>
      </Card>

      <Card className="bg-white shadow-sm">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium text-gray-700">This Week</CardTitle>
          <TrendingUp className="h-3 w-3 md:h-4 md:w-4 text-gray-600" />
        </CardHeader>
        <CardContent className="pt-1">
          <div className="text-lg md:text-2xl font-bold text-gray-900">{stats.thisWeek}</div>
        </CardContent>
      </Card>

      <Card className="bg-white shadow-sm">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium text-gray-700">Interview Interest</CardTitle>
          <Users className="h-3 w-3 md:h-4 md:w-4 text-gray-600" />
        </CardHeader>
        <CardContent className="pt-1">
          <div className="text-lg md:text-2xl font-bold text-gray-900">{stats.interviewInterested}</div>
        </CardContent>
      </Card>
    </div>
  );
};
